import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages/BlogHome.css';
import { posts } from '../mocks/MockPosts';

const BlogHome = () => {
  const categories = ['Techniques', 'Experiences', 'Niches', 'Jobs'];

  // Separate posts by author type
  const teamPosts = posts.filter((post) => post.author === 'Team');
  const photographerPosts = posts.filter((post) => post.author !== 'Team');

  return (
    <div className="blog-container blog-home">
      <h1>Blog</h1>

      {/* Category Navigation */}
      <nav className="blog-categories">
        <ul>
          {categories.map((category) => (
            <li key={category}>
              <Link to={`/blog/category/${category.toLowerCase()}`}>{category}</Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* Team Posts */}
      <section>
        <h2>Latest from Our Team</h2>
        {teamPosts.map((post) => (
          <div key={post.id} className="blog-post-excerpt">
            <h3>{post.title}</h3>
            <p>{post.excerpt}</p>
            <Link to={`/blog/${post.id}`}>Read more</Link>
          </div>
        ))}
      </section>

      {/* Photographer Posts */}
      <section>
        <h2>Insights from Photographers</h2>
        {photographerPosts.map((post) => (
          <div key={post.id} className="blog-post-excerpt">
            <h3>{post.title}</h3>
            <p>{post.excerpt}</p>
            <Link to={`/blog/${post.id}`}>Read more</Link>
          </div>
        ))}
      </section>

      {/* Write for Us Section */}
      <section className="write-for-us">
        {/* ... */}
      </section>
    </div>
  );
};

export default BlogHome;